// assets/byRavn-cart-messaging.js
// <delivery-estimate>: forventet levering + afsendelsesnedtælling på produktsiden og i kurven.
(function () {
  const ELEMENT_NAME = "delivery-estimate";
  // Snippets'ene indlæser filen flere gange på samme side; kun første kørsel registrerer.
  if (customElements.get(ELEMENT_NAME)) return;

  // En ugedag alene peger kun entydigt på en dato inden for den kommende uge.
  const WEEKDAY_IS_UNAMBIGUOUS_WITHIN_DAYS = 7;

  // ---------- i18n helpers ----------
  function i18n() {
    const d =
      typeof window !== "undefined" && window.brvI18n ? window.brvI18n : {};
    // Fallbacks hvis ikke injiceret:
    return {
      hourShort: d.hourShort || "h",
      shipOn: d.shipOn || "Order now and we'll ship your order on {day}",
      shipTomorrow:
        d.shipTomorrow || "Order now and we'll ship your order tomorrow",
      cutoff: d.cutoff || "Order within {countdown} and we'll ship today",
      weekdays:
        Array.isArray(d.weekdays) && d.weekdays.length === 7
          ? d.weekdays
          : [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
    };
  }
  function buildDayIndexMap() {
    const { weekdays } = i18n();
    const map = {};
    // Map fulde lokale navne til index
    weekdays.forEach((name, idx) => {
      if (!name) return;
      map[name.toLowerCase()] = idx;
      map[name.slice(0, 3).toLowerCase()] = idx; // 3-bogstavs alias, hvis det giver mening i sproget
    });
    // Tilsæt kendte aliaser (DK/EN) som fallback:
    Object.assign(map, {
      sun: 0,
      søn: 0,
      sunday: 0,
      søndag: 0,
      mon: 1,
      man: 1,
      monday: 1,
      mandag: 1,
      tue: 2,
      tir: 2,
      tuesday: 2,
      tirsdag: 2,
      wed: 3,
      ons: 3,
      wednesday: 3,
      onsdag: 3,
      thu: 4,
      tor: 4,
      thursday: 4,
      torsdag: 4,
      fri: 5,
      fre: 5,
      friday: 5,
      fredag: 5,
      sat: 6,
      lør: 6,
      saturday: 6,
      lørdag: 6,
    });
    return map;
  }
  const DAY_MAP = buildDayIndexMap();

  // ---------- utils ----------
  function pad(n) {
    return String(n).padStart(2, "0");
  }
  function localISODate(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
  function isHoliday(d, list) {
    return list.includes(localISODate(d));
  }
  function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }
  // Afrundet, så en sommertidsdag på 23 eller 25 timer stadig tæller som én.
  function calendarDaysBetween(from, to) {
    return Math.round((startOfDay(to) - startOfDay(from)) / 86400000);
  }

  // ---------- butiks-tidszone ----------
  // Al slot-matematik kører i butikkens vægur (data-tz), ikke enhedens.
  // shopNow giver en Date hvis lokale felter spejler butikkens vægur;
  // wallToInstant konverterer sådan et vægur-tidspunkt tilbage til et reelt instant.
  const TZ_FMT = {};
  function tzFormatter(tz) {
    if (!TZ_FMT[tz]) {
      TZ_FMT[tz] = new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false,
      });
    }
    return TZ_FMT[tz];
  }
  function tzParts(instant, tz) {
    const p = {};
    tzFormatter(tz).formatToParts(instant).forEach((x) => (p[x.type] = x.value));
    return p;
  }
  function shopNow(tz) {
    if (!tz) return new Date();
    try {
      const p = tzParts(new Date(), tz);
      return new Date(+p.year, p.month - 1, +p.day, p.hour % 24, +p.minute, +p.second);
    } catch (e) {
      return new Date();
    }
  }
  function tzOffset(instant, tz) {
    const p = tzParts(instant, tz);
    return (
      Date.UTC(+p.year, p.month - 1, +p.day, p.hour % 24, +p.minute, +p.second) -
      instant.getTime()
    );
  }
  function wallToInstant(wall, tz) {
    if (!tz) return wall;
    try {
      const wallMs = Date.UTC(
        wall.getFullYear(),
        wall.getMonth(),
        wall.getDate(),
        wall.getHours(),
        wall.getMinutes(),
        wall.getSeconds()
      );
      const guess = wallMs - tzOffset(new Date(wallMs), tz);
      return new Date(wallMs - tzOffset(new Date(guess), tz));
    } catch (e) {
      return wall;
    }
  }

  // ---------- datoformat ----------
  // data-locale er sprog + marked ("da-DK", "en-DE"), så Intl vælger både ugedagens
  // skrivemåde (dansk "fredag", tysk "Freitag") og datoformatet for markedet.
  function resolveLocale(root) {
    try {
      return new Intl.Locale(root.dataset.locale).toString();
    } catch (e) {
      return document.documentElement.lang || undefined;
    }
  }

  function capitalize(s, locale) {
    return s ? s.charAt(0).toLocaleUpperCase(locale) + s.slice(1) : s;
  }

  function weekdayLong(d, locale) {
    return new Intl.DateTimeFormat(locale, { weekday: "long" }).format(d);
  }

  // Måneden skrives ud: "2/10" er 2. oktober for en europæer og 10. februar for en
  // amerikaner, "2. oktober" kan ikke misforstås. formatRange deler måneden i et interval
  // ("fredag 2.–tirsdag 6. oktober"), så intervallet ikke bliver længere end før.
  function formatEta(etaStart, etaEnd, today, locale) {
    const withDate = { weekday: "long", day: "numeric", month: "long" };
    if (etaEnd) {
      // Midt i sætningen ("Forventet levering fredag 2.–…"): sprogets egen skrivemåde.
      return new Intl.DateTimeFormat(locale, withDate).formatRange(etaStart, etaEnd);
    }
    const daysAhead = calendarDaysBetween(today, etaStart);
    const options =
      daysAhead < WEEKDAY_IS_UNAMBIGUOUS_WITHIN_DAYS ? { weekday: "long" } : withDate;
    // Står alene efter kolon ("Forventet levering: Tirsdag"): stort begyndelsesbogstav.
    return capitalize(new Intl.DateTimeFormat(locale, options).format(etaStart), locale);
  }

  // ---------- afsendelse og levering ----------
  function parseSlots(s) {
    if (!s) return [];
    return s
      .split(",")
      .map((x) => x.trim())
      .map((tok) => {
        // Eksempler: "Mandag 15:00", "Monday 15:00", "Ons 9:30"
        const m = tok.match(/^([A-Za-zÆØÅæøå]+)\s+(\d{1,2}):(\d{2})$/);
        if (!m) return null;
        const key = m[1].toLowerCase();
        const dow = DAY_MAP[key];
        if (dow == null) return null;
        return { dow, h: +m[2], m: +m[3] };
      })
      .filter(Boolean)
      .sort((a, b) => a.dow - b.dow || a.h - b.h || a.m - b.m);
  }

  function nextSlotAfter(now, slots, { holidays }) {
    if (!slots.length) {
      const x = new Date(now);
      x.setDate(x.getDate() + 1);
      x.setHours(15, 0, 0, 0);
      return x;
    }
    for (let i = 0; i < 21; i++) {
      const d = new Date(now);
      d.setDate(d.getDate() + i);
      for (const s of slots) {
        if (d.getDay() !== s.dow) continue;
        const cand = new Date(d);
        cand.setHours(s.h, s.m, 0, 0);
        if (cand <= now) continue;
        if (isHoliday(cand, holidays)) continue;
        return cand;
      }
    }
    const x = new Date(now);
    x.setDate(x.getDate() + 1);
    x.setHours(15, 0, 0, 0);
    return x;
  }

  // Lagerets arbejdsdage (man–fre uden helligdage), uafhængigt af markedets afsendelsesslots:
  // Norge sender kun mandag og onsdag, men et portræt er klar efter to hverdage uanset marked.
  function addBusinessDays(start, days, holidays) {
    const d = new Date(start);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const weekend = d.getDay() === 0 || d.getDay() === 6;
      if (weekend || isHoliday(d, holidays)) continue;
      added++;
    }
    return d;
  }

  // Varen er klar det antal hverdage efter den normale afsendelse og går med
  // markedets første slot den dag eller senere.
  function dispatchAfterExtraBusinessDays(normalDispatch, extraBusinessDays, slots, holidays) {
    if (extraBusinessDays <= 0) return normalDispatch;
    const readyDay = addBusinessDays(normalDispatch, extraBusinessDays, holidays);
    return nextSlotAfter(startOfDay(readyDay), slots, { holidays });
  }

  function addDeliveryDays(start, days, { deliverSaturday, deliverSunday, holidays }) {
    let d = new Date(start),
      added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const skipped =
        (d.getDay() === 6 && !deliverSaturday) ||
        (d.getDay() === 0 && !deliverSunday) ||
        isHoliday(d, holidays);
      if (skipped) continue;
      added++;
    }
    return d;
  }

  function formatCountdown(ms, L) {
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return `${pad(h)}${L.hourShort} ${pad(m)}m ${pad(s)}s`;
  }

  // Tikker mod den normale afsendelsesdeadline og genberegner, når den passeres, så
  // leveringsdatoen ruller videre. Uden nedtællingselement (produkter med ekstra hverdage
  // før afsendelse) tikker den kun for at rulle.
  function tickTo(root, countdownEl, wallDeadline, tz, locale) {
    clearInterval(root.ticker);
    const L = i18n();
    const deadline = wallToInstant(wallDeadline, tz);
    const dispatchDay = localISODate(wallDeadline);
    // Ugedagsteksten er konstant for denne deadline — Intl-formatteren er dyr at bygge,
    // så den holdes ude af tikket.
    const shipOnText = L.shipOn.replace("{day}", weekdayLong(wallDeadline, locale));

    const write = (text) => {
      if (countdownEl.textContent !== text) countdownEl.textContent = text;
    };

    const paint = (allowRollover) => {
      const ms = deadline - new Date();

      if (ms <= 0) {
        // Deadline passeret: genberegn til næste afsendelsesslot i stedet for at fryse
        if (allowRollover) hydrate(root);
        return;
      }
      if (!countdownEl) return;

      // Nedtællingen vises kun når afsendelsen sker i dag. Er afsendelsen først i
      // morgen, koster det intet at misse deadlinen, og uret ville tælle ned til ingenting.
      const today = shopNow(tz);
      if (dispatchDay === localISODate(today)) {
        write(L.cutoff.replace("{countdown}", formatCountdown(ms, L)));
        return;
      }

      // "på tirsdag" kan læses som næste tirsdag, så i morgen siges relativt.
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      write(dispatchDay === localISODate(tomorrow) ? L.shipTomorrow : shipOnText);
    };
    paint(false);
    root.ticker = setInterval(() => paint(true), 1000);
  }

  // ---------- hydrering ----------
  function hydrate(root) {
    const slots = parseSlots((root.dataset.slots || "").trim());
    const parsedTransit = parseInt(root.dataset.transitDays, 10);
    const transit = Number.isNaN(parsedTransit) ? 1 : parsedTransit;
    const extraBusinessDaysBeforeDispatch =
      parseInt(root.dataset.extraBusinessDaysBeforeDispatch || "0", 10) || 0;
    const deliveryDays = {
      deliverSaturday: root.dataset.deliverSaturday === "true",
      deliverSunday: root.dataset.deliverSunday === "true",
    };
    const holidays = (root.dataset.holidays || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const etaEl = root.querySelector('[data-role="eta-date"]');
    const countdownEl = root.querySelector('[data-role="dispatch-countdown"]');
    const etaMode = root.dataset.etaMode || "single";
    const transitSpan = parseInt(root.dataset.transitSpan || "0", 10) || 0;
    const tz = (root.dataset.tz || "").trim();
    const locale = resolveLocale(root);

    const now = shopNow(tz);
    const normalDispatch = nextSlotAfter(now, slots, { holidays });
    const dispatch = dispatchAfterExtraBusinessDays(
      normalDispatch,
      extraBusinessDaysBeforeDispatch,
      slots,
      holidays
    );
    const etaStart = addDeliveryDays(dispatch, transit, { ...deliveryDays, holidays });
    const etaEnd =
      etaMode === "range" && transitSpan > 0
        ? addDeliveryDays(etaStart, transitSpan, { ...deliveryDays, holidays })
        : null;

    if (etaEl) etaEl.textContent = formatEta(etaStart, etaEnd, now, locale);
    tickTo(root, countdownEl, normalDispatch, tz, locale);
  }

  // Dawn erstatter kurvens markup ved hver ændring. Et nyt element hydrerer sig selv, når
  // det indsættes, og et fjernet stopper sit interval — ingen kurv-event skal huskes.
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      hydrate(this);
    }
    disconnectedCallback() {
      clearInterval(this.ticker);
    }
  }
  customElements.define(ELEMENT_NAME, DeliveryEstimate);

  // Chrome throttler i baggrundsfaner fryser intervallet — genberegn når fanen bliver synlig
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) document.querySelectorAll(ELEMENT_NAME).forEach(hydrate);
  });
})();
